import { createApp } from 'vue'
import FundraisingCard from './FundraisingCard'

const el = '.kb-component--fundraising-card'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((FundraisingCardDOM) => {
            const component = createApp(FundraisingCard).use(Store)
            component.mount(FundraisingCardDOM)
        })
    }
}
